// Zona 2 — Cola V3 con separación RÍGIDA: ALARMAS DE PERSONA (arriba) e INCIDENCIAS TÉCNICAS (abajo).
// Cuando hay alarmas humanas, las técnicas se muestran reducidas (contador total visible) y expandibles.
import { useState } from "react";
import { UserRound, Wrench, CheckCircle2, ChevronDown, ChevronUp } from "lucide-react";
import AlarmCardV3 from "@/components/consolaV3/AlarmCardV3";
import ActividadReciente from "@/components/consolaV3/ActividadReciente";
import { ordenarCola } from "@/lib/consolaLib";
import { esTecnica } from "@/lib/consolaV3/meta";

const TECNICAS_COLAPSADAS = 3;

export default function QueueV3({ alarmas, selectedId, onSelect, nowMs, stale, actividad = [] }) {
  const [expandTec, setExpandTec] = useState(false);
  const persona = ordenarCola(alarmas.filter((a) => !esTecnica(a) && a.estado !== "cerrada"), nowMs);
  const tecnicas = ordenarCola(alarmas.filter((a) => esTecnica(a) && a.estado !== "cerrada"), nowMs);

  // Colapsar sólo cuando hay alarmas humanas compitiendo por la columna operativa.
  const colapsar = persona.length > 0 && tecnicas.length > TECNICAS_COLAPSADAS && !expandTec;
  const tecnicasVisibles = colapsar ? tecnicas.slice(0, TECNICAS_COLAPSADAS) : tecnicas;

  return (
    <div className="flex h-full flex-col">
      {/* ALARMAS DE PERSONA */}
      <div className="flex-1 min-h-0 overflow-y-auto p-3 space-y-2.5">
        <div className="flex items-center justify-between px-0.5">
          <p className="flex items-center gap-1.5 text-[11px] font-bold uppercase tracking-wider text-[#012472]">
            <UserRound className="h-3.5 w-3.5" /> Alarmas de persona
          </p>
          <span data-testid="v3-count-persona" className="rounded-full bg-slate-200 px-2 py-0.5 text-[11px] font-bold tabular-nums text-slate-600 dark:text-slate-300">{persona.length}</span>
        </div>
        {persona.length === 0 ? (
          <div data-testid="v3-persona-vacia" className="flex flex-col items-center gap-1.5 rounded-lg border border-dashed border-slate-200 py-8 text-center">
            <CheckCircle2 className="h-6 w-6 text-[#01CBE3]/70" />
            <p className="text-xs text-slate-400 dark:text-slate-500">Sin alarmas de persona</p>
          </div>
        ) : (
          persona.map((a) => <AlarmCardV3 key={a.id} alarma={a} selected={a.id === selectedId} onSelect={onSelect} nowMs={nowMs} stale={stale} />)
        )}
      </div>

      {/* ACTIVIDAD RECIENTE — eventos activos de prioridad BAJA (informativo, sin alarma) */}
      <ActividadReciente eventos={actividad} />

      {/* INCIDENCIAS TÉCNICAS — separadas abajo, colapsables cuando hay alarmas humanas */}
      <div className="shrink-0 border-t-2 border-dashed border-[#9B2C2C]/25 bg-slate-50/60 max-h-[42%] overflow-y-auto p-3 space-y-2.5">
        <div className="flex items-center justify-between px-0.5">
          <p className="flex items-center gap-1.5 text-[11px] font-bold uppercase tracking-wider text-[#9B2C2C] dark:text-[#F2B8B8]">
            <Wrench className="h-3.5 w-3.5" /> Incidencias técnicas
          </p>
          <span data-testid="v3-count-tecnicas" className="rounded-full bg-[#9B2C2C]/15 px-2 py-0.5 text-[11px] font-bold tabular-nums text-[#9B2C2C] dark:text-[#F2B8B8]">{tecnicas.length}</span>
        </div>
        {tecnicas.length === 0 ? (
          <p data-testid="v3-tecnicas-vacia" className="py-3 text-center text-xs text-slate-400 dark:text-slate-600">Sin incidencias técnicas</p>
        ) : (
          <>
            {tecnicasVisibles.map((a) => <AlarmCardV3 key={a.id} alarma={a} selected={a.id === selectedId} onSelect={onSelect} nowMs={nowMs} stale={stale} />)}
            {(colapsar || (expandTec && tecnicas.length > TECNICAS_COLAPSADAS && persona.length > 0)) && (
              <button data-testid="v3-tecnicas-toggle" onClick={() => setExpandTec((v) => !v)}
                className="w-full inline-flex items-center justify-center gap-1.5 rounded-lg border border-[#9B2C2C]/30 px-3 py-1.5 text-xs font-semibold text-[#9B2C2C] dark:text-[#F2B8B8] hover:bg-[#9B2C2C]/10">
                {colapsar ? <><ChevronDown className="h-3.5 w-3.5" /> Ver todas ({tecnicas.length})</> : <><ChevronUp className="h-3.5 w-3.5" /> Ver menos</>}
              </button>
            )}
          </>
        )}
      </div>
    </div>
  );
}
